import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import { C, FONT_NUM } from './tokens';
import { fmtNum } from './formatters';

// Tooltip-equipped mini bar showing how each component contributes to the score.
const ScoreBreakdown = ({ comp, t }) => {
  if (!comp) return null;
  const segs = [
    { key: 'M', label: t('breakoutCandidates.components.market'), val: comp.market_score, color: '#3b82f6' },
    { key: 'S', label: t('breakoutCandidates.components.sector'), val: comp.sector_score, color: '#10b981' },
    { key: 'Q', label: t('breakoutCandidates.components.quality'), val: comp.quality_score, color: '#8b5cf6' },
    { key: 'SM', label: t('breakoutCandidates.components.smartMoney'), val: comp.smart_money_score, color: '#f59e0b' },
    { key: 'T', label: t('breakoutCandidates.components.trigger'), val: comp.trigger_score, color: '#ef4444' },
  ];
  const total = segs.reduce((a, b) => a + (b.val || 0), 0) || 1;
  const trap = comp.trap_penalty || 0;
  return (
    <Tooltip
      arrow
      title={
        <Box sx={{ p: 0.4, minWidth: 150 }}>
          {segs.map((s) => (
            <Box key={s.key} sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
              <span style={{ color: s.color, fontWeight: 700 }}>● {s.label}</span>
              <span style={{ fontFamily: FONT_NUM, fontWeight: 700 }}>{fmtNum(s.val, 1)}</span>
            </Box>
          ))}
          {trap > 0 ? (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#fca5a5', mt: 0.3 }}>
              <span>{t('breakoutCandidates.drawer.trapPenalty')}</span>
              <span style={{ fontFamily: FONT_NUM, fontWeight: 700 }}>−{fmtNum(trap, 1)}</span>
            </Box>
          ) : null}
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          height: 6,
          borderRadius: 99,
          overflow: 'hidden',
          minWidth: 110,
          bgcolor: C.borderSoft,
        }}
      >
        {segs.map((s) => (
          <Box key={s.key} sx={{ width: `${((s.val || 0) / total) * 100}%`, bgcolor: s.color }} />
        ))}
      </Box>
    </Tooltip>
  );
};

ScoreBreakdown.propTypes = {
  comp: PropTypes.shape({
    market_score: PropTypes.number,
    sector_score: PropTypes.number,
    quality_score: PropTypes.number,
    smart_money_score: PropTypes.number,
    trigger_score: PropTypes.number,
    trap_penalty: PropTypes.number,
  }),
  t: PropTypes.func.isRequired,
};

ScoreBreakdown.defaultProps = {
  comp: null,
};

export default ScoreBreakdown;
